import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { Config } from '@shared/types';

import { environment } from '@environments/environment';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', async () => {
  const response = await fetch(`config.json?t=${Date.now()}`);
  const config: Config = await response.json();

  if (config.isApiMocked) {
    const { worker } = await import('./mocks/browser');
    await worker(config.backendRootUrl)
      .start({
        serviceWorker: { url: '/mockServiceWorker.js' },
        onUnhandledRequest: (request, print) => {
          // Disable warnings for unhandled network requests fetched from the dev server, excluding the api requests
          if (request.url.startsWith(location.origin) && !location.pathname.startsWith(`/v1`)) {
            return;
          }

          print.warning();
        },
      })
      .catch((error: Error) => console.error(error));
  }

  bootstrapApplication(AppComponent, appConfig(config)).catch((error: Error) => console.error(error));
});
